<template>
    <div id="app">
        <component :is="currentAppByDevice"/>
    </div>
</template>

<script>
const AppPcMain = () => import(/* webpackChunkName: "main" */ '@/pages/app/AppPc')
const AppMobileMain = () => import(/* webpackChunkName: "main" */ '@/pages/app/AppMobile')
export default {
    name : 'Main'
    , data () {
        return {}
    }
    , computed : {
        currentAppByDevice () {
            return (templateDevice == 'pc') ? AppPcMain : AppMobileMain;
        }
    }
}
</script>
